module.exports = __webpack_public_path__ + "img/Incorrect Weight.abbefd72.png";